/**
 * BackgroundPreferenceContext
 *
 * Provided by DashboardLayout so any descendant (e.g. the "Apariencia"
 * selector on the Profile/Settings page) can read and change the dashboard
 * background preference and see it reflected instantly, without prop
 * drilling through the ~30 pages that render <DashboardLayout>.
 *
 * @module contexts/BackgroundPreferenceContext
 */

import { createContext, useContext } from 'react';

export const BackgroundPreferenceContext = createContext(null);

/**
 * @returns {{
 *   preference: {mode: string, fixedImageId: string},
 *   resolvedBackground: string,
 *   setMode: (mode: string) => void,
 *   setFixedImageId: (id: string) => void,
 *   modeOptions: Array,
 *   imageOptions: Array,
 * }}
 */
export const useBackgroundPreferenceContext = () => {
  const ctx = useContext(BackgroundPreferenceContext);
  if (!ctx) {
    throw new Error(
      'useBackgroundPreferenceContext must be used within a <DashboardLayout> tree'
    );
  }
  return ctx;
};

export default BackgroundPreferenceContext;
